/**
 * Helpers for the patient-allergy summary UI.
 */
import type { AllergyItem, AllergyResponse } from "./types";

/** Normalize the streamed allergy_response into a safe AllergyItem[] (never throws). */
export function allergyResponseToItems(
  response: AllergyResponse | null | undefined
): AllergyItem[] {
  if (!response || !Array.isArray(response.allergies)) return [];
  return response.allergies
    .filter((a): a is AllergyItem => !!a && typeof a === "object")
    .map((a) => ({
      drugName: (a.drugName ?? "").toString().trim(),
      reactions: Array.isArray(a.reactions)
        ? a.reactions.map((r) => (r ?? "").toString().trim()).filter(Boolean)
        : [],
      onSetDate: (a.onSetDate ?? "").toString().trim(),
      note: (a.note ?? "").toString().trim(),
      allergyStatusFlag: (a.allergyStatusFlag ?? "").toString().trim(),
    }))
    .filter((a) => a.drugName.length > 0);
}

export function isActiveAllergy(flag: string | undefined): boolean {
  return (flag ?? "").toString().trim().toLowerCase() === "active";
}

/** Active allergies render with the error/danger ramp; inactive ones are de-emphasized. */
export function getAllergyStatusColor(flag: string | undefined): "error" | "default" {
  return isActiveAllergy(flag) ? "error" : "default";
}
